const set = require('regenerate')(0x301, 0x304, 0x30B, 0x358);
set.addRange(0x104B0, 0x104D3).addRange(0x104D8, 0x104FB);
exports.characters = set;
